/**
 * Created by Mike Naughton on 2/20/18.
 */

import LoggingContext from "app/LoggingContext";
import FeatureResults from "app/models/map/FeatureResults";
var MapContextBase = LoggingContext.extend({
  constructor: function (slug, root) {
    LoggingContext.call(this, slug, root);

    this._plugins = []; //array of map plugin results - i.e. bootstrap()->map()
    this._region = null;
    this.clearSelection();

    var self = this;

    Object.defineProperty(this, "plugins", {
      get: function () {
        return self.getPlugins();
      },
    });
  },

  /**
   * Sets the currently-selected service of the map.
   * @param {MapServiceBase} service The selected service.
   */
  setSelectedService: function (service) {
    this._service = service;
    this.getConfiguration().setActiveService(service);
    this.trigger("select:service", service);
  },

  /**
   * Gets the currently-selected service of the map.
   * @return {MapServiceBase} The selected service.
   */
  getSelectedService: function () {
    return this._service;
  },

  /**
   * Sets the currently-selected layer of the map.
   * @param {MapLayerBase} layer The selected layer.
   */
  setSelectedLayer: function (layer) {
    this._layer = layer;
    this.getConfiguration().setActiveLayer(layer);
    this.trigger("select:layer", layer);
  },

  /**
   * Gets the currently-selected layer of the map.
   * @return {MapLayerBase} The selected layer.
   */
  getSelectedLayer: function () {
    return this._layer;
  },

  setConfiguration: function (config) {
    this._service = null;
    this._layer = null;
    this._config = config;
    this.trigger("change:configuration");
  },

  /**
   * Gets the configuration for this context.
   * @return {Layout} The layer configuration.
   */
  getConfiguration: function () {
    return this._config;
  },

  /**
   * Gets an array of map plugin instances.
   * @return {MapPlugin[]} Array of `MapPlugin` instances.
   */
  getPlugins: function () {
    return this._plugins;
  },

  /**
   * Clears the selected features of the map.
   */
  clearSelection: function () {
    this.setSelection([]);
  },

  /**
   * Sets the selected features.
   * @param {Array|Backbone.Collection} selection Array or backbone collection of selected features.
   */
  setSelection: function (selection) {
    if (selection instanceof FeatureResults) {
      this._selection = selection;
    } else {
      this._selection = new FeatureResults(selection || []);
    }
    this.trigger("change:selection", this._selection);
  },

  /**
   * Gets the list of selected features. Selected features are those which have been selected by the user for operations to be performed on, including search results.
   * @return {FeatureResults} The set of selected features.
   */
  getSelection: function () {
    return this._selection;
  },

  /**
   * Clears the search region.
   */
  clearSearchRegion: function () {
    this.setSearchRegion([]);
  },

  /**
   * Sets the features on which to base a spatial search.
   * @param {Array|Backbone.Collection} region The search feature
   */
  setSearchRegion: function (region) {
    if (region instanceof FeatureResults) {
      this._region = region;
    } else {
      this._region = new FeatureResults(region || []);
    }
    this.trigger("change:region", this._region);
  },

  /**
   * Gets the features on which to base a spatial search.
   * @return {Array|Backbone.Collection} The search feature.
   */
  getSearchRegion: function () {
    return this._region;
  },

  /**
   * Gets the map associated with this view.
   * @return {esri.Map} The map instance.
   */
  getMap: function () {
    return this._map;
  },

  /**
   * Sets the map associated with this view.
   * @param {esri.Map} map The map instance.
   */
  setMap: function (map) {
    this._map = map;
  },

  /**
   * Display the given model to the user. Fires the "change:display" event, passing the given model.
   * @param model An object to display.
   */
  display: function (model) {
    this.trigger("change:display", model);
  },
});

export default MapContextBase;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/MapContextBase.js
// module id = 872
// module chunks = 1